
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class IconArrow extends Vue{
  @Prop({ default: 'currentColor' }) fill!: string;
  @Prop({ default: 'left' }) direction!: string;
}
